<template>
  <v-dialog
    v-model="consentConfig.showConsent"
    fullscreen
    transition="dialog-bottom-transition"
    persistent
   data-qa="consentoverlay-dialog-rke67q">
    <v-card data-qa="consentoverlay-card-hrganm">
      <v-row class="px-5 pt-2" data-qa="consentoverlay-row-nwd0zp">
        <img data-qa="consentoverlay-img-y366s"
          alt="logo"
          height="80px"
          width="140px"
          :src="logo"
          id="images"
          class="loginTitle"
        />
        <v-spacer data-qa="consentoverlay-spacer-xi4a0u"></v-spacer>
        <v-icon @click="goBack" class="px-3" data-qa="consentoverlay-icon-9k1fhh">mdi-close</v-icon>
      </v-row>
      <v-card-title class="pb-2" data-qa="consentoverlay-card-title-znznb">{{ $t('termsAndConditions.title') }}</v-card-title>
      <v-card-subtitle v-if="!enableReadOnlyMode" class="pt-2" data-qa="consentoverlay-card-subtitle-esuanf">{{ $t('termsAndConditions.subtitle') }}</v-card-subtitle>
      <v-card-text v-if="consentConfig.consentArray && consentConfig.consentArray?.length > 0" class="text-center" data-qa="consentoverlay-card-text-98moli">
        <v-row v-for="(item,i) in consentConfig.consentArray" :key="i" lg="12" :data-qa="`consentoverlay-row-uzzhu-${i}`">
          <v-expansion-panels
            v-model="expandPanel"
            multiple
            :mandatory="true"
            :readonly="enableReadOnlyMode"
            :data-qa="`consentoverlay-expansion-panels-d3axk9-${i}`">
            <v-expansion-panel class="pb-5"  :data-qa="`consentoverlay-expansion-panel-9pgvz-${i}`">
              <v-expansion-panel-header :data-qa="`consentoverlay-expansion-panel-header-zgr2l-${i}`">
                <v-row align="center" justify="center" :data-qa="`consentoverlay-row-tmbu5l-${i}`">
                  {{ item.consentType }}
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pdf-viewer" :id="`pdf-viewer-${i}`" :data-qa="`consentoverlay-expansion-panel-content-j7kh3oi-${i}`">
                <!-- PDF preview -->
                  <!-- Do not remove the below line. This is a workaround to get the number of pages in a document -->
                  <pdf style="display: none;" :src="docs[item.consentType].content" @num-pages="($event) => handlePageCount($event, item.consentType)"/>
                  <pdf v-for="(page, index) in docs[item.consentType].pageCount"
                    :key="index"
                    :src="docs[item.consentType].content"
                    :page="index + 1"
                    :onload="assignEventListener(item.consentInfo, i)"
                    class="pdf-page"
                  ></pdf>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-layout v-if="!enableReadOnlyMode" :data-qa="`consentoverlay-layout-1q3b3-${i}`">
              <v-flex class="text-start pa-5" lg11 :data-qa="`consentoverlay-flex-vhxfgl-${i}`">
                <v-btn @click="downloadConsent(item.consentInfo)" :color="secondaryColor" text :data-qa="`consentoverlay-btn-hii5e-${i}`">
                  <v-icon left :color="secondaryColor" size="18px" class="material-symbols-outlined" :data-qa="`consentoverlay-icon-415l0f-${i}`">
                    download
                  </v-icon>{{ $t('termsAndConditions.actions.download') }}</v-btn>
              </v-flex>
              <v-flex v-if="consentConfig.consentArray?.length > 1" lg1 :data-qa="`consentoverlay-flex-ygb24-${i}`">
                <span class="text-end" :data-qa="`consentoverlay-span-njxch-${i}`">
                <v-checkbox
                  v-model="consentAgreedCheckbox"
                  multiple
                  :label="$t('termsAndConditions.actions.agree')"
                  :disabled="acceptCheckBoxConfig[item.consentType]"
                  :value="item.consentType"
                  :color="primaryColor"
                  :data-qa="`consentoverlay-checkbox-w2e28-${i}`"></v-checkbox>
                </span>
              </v-flex>
            </v-layout>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-row v-if="!enableReadOnlyMode && consentConfig.consentArray?.length > 0" justify="center" data-qa="consentoverlay-row-pzp4ij">
        <v-card-actions class="justify-center" data-qa="consentoverlay-card-actions-y2lxzs">
          <v-btn
            v-if="consentConfig.consentArray?.length > 1"
            @click="confirmConsent('multipleConsent')"
            :disabled="disableConsentButtons"
            :color="primaryColor"
            class="white--text py-2 px-4"
           data-qa="consentoverlay-btn-enrnn">{{ $t('termsAndConditions.actions.confirm') }}</v-btn>
          <v-btn
            v-else
            @click="confirmConsent('singleConsent')"
            :color="primaryColor"
            class="white--text py-2 px-4"
            :disabled="acceptCheckBoxConfig[consentConfig.consentArray[0].consentType] || disableContinueBtnOnApiCall"
           data-qa="consentoverlay-btn-86nmhm">{{ $t('termsAndConditions.actions.continue') }}</v-btn>
            <!-- :disabled="disableConsentButtons()" -->
        </v-card-actions>
      </v-row>
      <v-row v-if="!enableReadOnlyMode && enableSkipTCOption" justify="center" data-qa="consentoverlay-row-ucwi4j">
        <v-btn v-if="consentConfig.isUpdateConsentAvailable" @click="routeToHome" :color="secondaryColor" text data-qa="consentoverlay-btn-clmk97">
          {{ $t('termsAndConditions.actions.skip') }}
        </v-btn>
      </v-row>
      <v-row v-if="!enableReadOnlyMode" class="text-center" justify="center" data-qa="consentoverlay-row-5uzvah">
        <v-col data-qa="consentoverlay-col-vu5su">
          <a
            :style="{ color: primaryColor }"
            class="px-2"
            target="_blank"
            @click="openFaq"
           data-qa="consentoverlay-a-ac4xss">
            <span v-cloak data-qa="consentoverlay-span-vnhuou">{{ $t("common.support") }}</span>
          </a>
          /
          <a
            :style="{ color: primaryColor }"
            class="px-2"
            target="_blank"
            @click="openContactUs"
           data-qa="consentoverlay-a-inq2yr">
            <span v-cloak data-qa="consentoverlay-span-bvgj1">{{ $t("common.finastraContactLink") }}</span>
          </a>
          <v-icon large data-qa="consentoverlay-icon-v8zhwd">mdi-shield-account</v-icon>
          <font :color="primaryColor" class="font-weight-bold">
            <span v-cloak data-qa="consentoverlay-span-lwkpq">{{ $t("common.secure") }}</span>
          </font>
          <font class="text-lowercase">
            <span v-cloak data-qa="consentoverlay-span-g8aixa">{{
              $t("common.loginButtonPlaceholder")
            }}</span></font
          >
        </v-col>
      </v-row>
    </v-card>
    <Modal :config="modalConfig" @cancel="modalConfig.enabled = false">
      <span slot="modalContent" class="font-weight-bold" data-qa="consentoverlay-span-l6klzq">
        <DobFAQ />
      </span>
    </Modal>
    <Loader v-if="loaderEnabled" />
  </v-dialog>
</template>

<script>
import CommonService from '@/service/commonService.js'
import Loader from '@/components/common/Loader.vue'
import event from '@/util/event'
import pdf from '@teckel/vue-pdf'

export default {
  name: 'ConsentOverlay',
  props: {
    consentConfig: {
      type: Object,
      default () {
        return {
          showConsent: false,
          consentArray: [],
          isUpdateConsentAvailable: false
        }
      }
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    DobFAQ: () => import('@/views/common/DobFAQ.vue'),
    pdf,
    Loader
  },
  data () {
    return {
      notifications: false,
      expandPanel: [],
      consentAgreedCheckbox: [],
      enableTermsAndConditionsConsent: this.$appSettings.defaultConfigurations.consentManagement.enableConsent,
      enableTCForceRead: this.$appSettings.defaultConfigurations.consentManagement.enableForceRead,
      checkUpdatedTCTillDate: this.$appSettings.defaultConfigurations.consentManagement.checkUpdatedTCTillDate,
      enableSkipTCOption: this.$appSettings.defaultConfigurations.consentManagement.enableSkipTCOption,
      checkUpdatedTCFromDate: '',
      enableReadOnlyMode: false,
      modalConfig: {
        btn1Label: 'OK',
        outlinedSaveBtn: false,
        outlinedCancelBtn: true,
        enabled: false,
        persistent: true,
        saveButton: '',
        title: this.$t('login.faq.faqTitle'),
        width: 700
      },
      counter: this.consentConfig.consentArray.length,
      acceptCheckBoxConfig: {},
      docs: {},
      loaderEnabled: false,
      disableContinueBtnOnApiCall: false
    }
  },
  mounted () {
    this.enableReadOnlyMode = this.$route.name === 'Home'
  },
  created () {
    if (this.consentConfig.consentArray?.length > 0) {
      event.$emit('consentScreenIsOpen', true)
      this.consentConfig.consentArray.forEach(consent => {
        this.acceptCheckBoxConfig[consent.consentType] = this.enableTermsAndConditionsConsent && this.enableTCForceRead
        this.docs[consent.consentType] = {
          content: `data:application/pdf;base64,${consent.consentInfo.contents}#toolbar=0`,
          pageCount: []
        }
      })
    }

    event.$on('consentScreenIsOpen', (isOpen) => {
      !isOpen && this.goBack()
    })
  },
  computed: {
    disableConsentButtons () {
      let disableConsentButtons = false
      if (this.enableTermsAndConditionsConsent) {
        if (this.consentAgreedCheckbox?.length && this.consentAgreedCheckbox?.length === this.consentConfig.consentArray?.length) {
          disableConsentButtons = false
        } else disableConsentButtons = true
        if (this.disableContinueBtnOnApiCall) {
          disableConsentButtons = true
        }
      }
      return disableConsentButtons
    }
  },
  methods: {
    handlePageCount (e, ct) {
      if (e) {
        this.docs = {
          ...this.docs, [ct]: { ...this.docs[ct], pageCount: new Array(e) }
        }
      }
    },
    goBack () {
      this.consentConfig.showConsent = false
      if (this.$route.name === 'Login') {
        event.$emit('resetLoginForm')
      }
    },
    routeToHome () {
      event.$emit('routeToHome', true)
    },
    openContactUs () {
      window.open(this.$appSettings.applicationSettings.contactUs)
    },
    openFaq () {
      this.modalConfig.enabled = true
    },
    handleScrollEvent (e, consentInfo) {
      if (e.target.scrollHeight - (e.target.clientHeight + 10) <= Math.ceil(e.target.scrollTop) && this.acceptCheckBoxConfig[consentInfo.entityCode]) {
        this.acceptCheckBoxConfig = { ...this.acceptCheckBoxConfig, [consentInfo.entityCode]: false }
      }
    },
    assignEventListener (consentInfo, i) {
      if (this.enableTCForceRead) {
        const viewerContainer = document.getElementById(`pdf-viewer-${i}`)

        if (viewerContainer) {
          viewerContainer.addEventListener('scroll', (e) => {
            this.handleScrollEvent(e, consentInfo)
          })
        }
      }
    },
    downloadConsent (consentInfo) {
      const base64ImageData = `data:application/pdf;base64,${consentInfo.contents}#toolbar=0`
      const fileName = `${consentInfo.entityCode}${this.$t('termsAndConditions.actions.downloadFileNameSuffix')}`
      const a = document.createElement('a') // Create <a data-qa="consentoverlay-a-h13ko">
      a.href = base64ImageData // Image Base64 Goes here
      a.download = fileName
      a.click()
    },
    confirmConsent (totalConsents) {
      this.loaderEnabled = true
      this.disableContinueBtnOnApiCall = true
      let filteredConsent = []
      const consentArray = []
      if (totalConsents === 'singleConsent') {
        filteredConsent = this.consentConfig?.consentArray
      } else {
        filteredConsent = this.consentConfig?.consentArray?.filter((consent) => this.consentAgreedCheckbox?.includes(consent.consentType))
      }
      filteredConsent.forEach(consent => {
        consentArray?.push({
          consentCode: consent?.consentInfo?.entityCode,
          consentVersion: consent?.consentInfo?.consentVersion
        })
      })
      this.createCustomerConsent(consentArray)
    },
    async createCustomerConsent (consentArray) {
      // this.loaderEnabled = true
      try {
        const payload = {
          readOnlyFlag: 'N',
          activeFlag: 'Y',
          customerId: JSON.parse(sessionStorage.getItem('isSmeLogin')) // SME party ID should be in customerId
            ? JSON.parse(sessionStorage.getItem('corporateId'))
            : JSON.parse(sessionStorage.getItem('username')),
          consentGivenCustomerId: JSON.parse(sessionStorage.getItem('isSmeLogin')) // Individual party ID of the trustee should be in consentGivenCustomerId
            ? JSON.parse(sessionStorage.getItem('customerCode'))
            : '',
          channelCode: 'DOB',
          consents: consentArray
        }
        const customerConsentCreationResponse = await CommonService.createCustomerConsent(payload)
        if (customerConsentCreationResponse && !customerConsentCreationResponse.causes) {
          this.routeToHome()
        }
      } catch (error) {
        this.disableContinueBtnOnApiCall = false
        console.error('Error creating customer consent:', error)
      } finally {
        this.loaderEnabled = false
      }
    }
  },
  watch: {
    'consentConfig.consentArray' () {
      if ((this.expandPanel?.length === 0) && (this.consentConfig.consentArray?.length > 0)) {
        this.expandPanel = []
        this.expandPanel = [...Array(this.consentConfig.consentArray).keys()].map((k, i) => i)
      }
    }
  },
  beforeDestroy () {
    if (this.consentConfig.consentArray.length > 0 && this.enableTCForceRead) {
      this.consentConfig.consentArray.forEach((consent, i) => {
        const viewerContainer = document.getElementById(`pdf-viewer-${i}`)
        if (viewerContainer) {
          viewerContainer.removeEventListener('scroll', this.handleScrollEvent)
        }
      })
    }
  }
}
</script>

<style scoped>
.pdf-viewer {
  padding: 10px;
  overflow-y: scroll;
  height: 600px;
  width: 85%;
  text-align: center;
  outline-style: solid;
  outline-width: 5px;
  outline-color: rgba(0, 0, 0, 0.4);
  margin: 0px auto;
  background-color: #303134;
}

.pdf-page {
  margin-bottom: 25px;
}
/** scrollbar styles */
/* Works on Firefox */
.pdf-viewer {
  scrollbar-width: thin;
  scrollbar-color: lightgray transparent;
}

/* Works on Chrome, Edge, and Safari */
.pdf-viewer::-webkit-scrollbar {
  width: 5px;
}

.pdf-viewer::-webkit-scrollbar-thumb {
  background-color: lightgray;
  border-radius: 20px;
}
</style>
